export default __webpack_public_path__ + "static/media/pin1.96fbe91f.svg";